// src/pages/TermsPage.js

import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

export default function TermsPage() {
  const { i18n } = useTranslation();
  const [terms, setTerms] = useState(null);

  useEffect(() => {
    const lang = i18n.language || "fr";
    fetch(`/locales/${lang}/terms.json`)
      .then((res) => res.json())
      .then(setTerms)
      .catch(() => console.error("❌ Erreur lors du chargement des CGU"));
  }, [i18n.language]);

  if (!terms) {
    return <p className="text-center mt-10">📄 Chargement des conditions d'utilisation...</p>;
  }

  return (
    <div className="max-w-4xl mx-auto px-5 sm:px-8 py-10 sm:py-14 text-slate-800">
      <h1 className="text-3xl sm:text-4xl font-extrabold tracking-tight text-[#245580] mb-3">{terms.title}</h1>
      <p className="text-sm text-slate-600 mb-10">{terms.last_update}</p>

      {terms.sections.map((section, index) => (
        <section key={index} className="mb-8">
          <h2 className="text-xl sm:text-2xl font-bold text-[#245580] mb-4">{section.title}</h2>
          {section.body && <p className="text-base leading-8 whitespace-pre-line mb-4">{section.body}</p>}
          {section.list && (
            <ul className="list-disc ml-6 space-y-3 text-base leading-7">
              {section.list.map((item, i) => (
                <li key={i}>{item}</li>
              ))}
            </ul>
          )}
        </section>
      ))}
    </div>
  );
}
